export { default as UnifiedPromptBar } from './unified-prompt-bar';
export type { 
  UnifiedPromptBarProps, 
  UnifiedPromptBarFeatures,
  UnifiedPromptBarConfig,
  SubmitParams 
} from './types';
export { usePromptBarTheme } from './hooks/usePromptBarTheme';
export type { PromptBarTheme, ThemeMode } from './hooks/usePromptBarTheme';
export { shadeHex } from './utils/color';

